import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68d8b9f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-gallery" }
const _hoisted_2 = ["title", "onClick"]
const _hoisted_3 = ["src", "alt"]

import { computed } from 'vue'
import { useBackgroundStore, useDeviceStore } from '@/stores'


export default /*#__PURE__*/_defineComponent({
  __name: 'BackgroundGallery',
  props: {
  disabled: {
    type: Boolean,
    default: false,
  },
  withBorder: {
    type: Boolean,
    default: false,
  },
},
  emits: ['select-background'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const backgroundStore = useBackgroundStore()
const deviceStore = useDeviceStore()
/**
 * Computed
 */
const backgroundOptions = computed(() => Array.from(backgroundStore.backgroundGallery.values()))
/**
 * Methods
 */

const selectBackground = (value: string) => {
  if (props.disabled) return
  if (backgroundStore.selectedBackground === value) return
  backgroundStore.selectedBackground = value
  deviceStore.maskCameraOn = true
  emit('select-background', backgroundStore.selectedBackground)
}

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(backgroundOptions.value, (image, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `img-gal-${index}`,
        class: _normalizeClass(["gallery-col", {
        active: image.value === _unref(backgroundStore).selectedBackground,
        disabled: __props.disabled,
        '--with-border': __props.withBorder,
      }])
      }, [
        _createElementVNode("div", {
          class: "image-box",
          title: image.name,
          onClick: ($event: any) => (selectBackground(image.value))
        }, [
          (image.type === 'image')
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: image.src,
                alt: image.name,
                class: "img-preview"
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createBlock(_component_SvgIcon, {
                key: 1,
                class: "close-icon",
                icon: image.path,
                "inherit-fill": true,
                height: "48"
              }, null, 8, ["icon"]))
        ], 8, _hoisted_2)
      ], 2))
    }), 128))
  ]))
}
}

})